module.exports = __webpack_public_path__ + "static/media/spinner.10da49cd.gif";